import { useModalStore } from '@/shared/lib';
import { EditCryptoAddressModal } from '../ui';
import type { SavedCryptoAddress } from '@/entities/crypto-address';

type Params = {
  savedCryptoAddress: SavedCryptoAddress;
  onBack: () => void;
};

export function useEditCryptoAddressModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openEditCryptoAddressModal = ({
    savedCryptoAddress,
    onBack,
  }: Params) => {
    showDialogComponent({
      component: (
        <EditCryptoAddressModal
          savedCryptoAddress={savedCryptoAddress}
          onBack={onBack}
        />
      ),
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openEditCryptoAddressModal };
}
